angular.module("app").config(function ($stateProvider, $urlRouterProvider) {
    var userData = document.getUserData && document.getUserData() || false,
        defaultRoute = "";

    $urlRouterProvider.when("", "/login");

    if (!!userData) {
        switch (userData.role) {
            case 'skin_news_manager':
                defaultRoute = 'main.pages.list.news';
                break;
            case 'casino_general_admin':
                defaultRoute = 'main.providers.add';
                break;
            case 'skin_casino_manager':
                defaultRoute = 'main.casinoGames.list';
                break;
            default :
                defaultRoute = 'main.configs';
                break
        }
    } else {
        defaultRoute = 'main.configs';
    }

    $urlRouterProvider.otherwise(function ($injector) {
        $injector.invoke(['$state', function ($state) {
            $state.go(defaultRoute);
        }]);
    });

    $stateProvider
        .state('login', {
            url: "/login",
            templateUrl: "views/login.html",
            controller: "LoginController",
            ncyBreadcrumb: {
                skip: true
            }
        })
        .state('main', {
            abstract: true,
            url: "/",
            templateUrl: "views/home.html",
            controller: "HomePageController",
            ncyBreadcrumb: {
                skip: true
            }
        })
        .state('main.pages', {
            abstract: true,
            url: "pages",
            templateUrl: "views/pages/index.html",
            controller: "PagesPageController",
            ncyBreadcrumb: {
                skip: true
            }
        })
        .state('main.pages.add', {
            url: "/add",
            templateUrl: "views/pages/add.html",
            controller: "PagesAddPageController",
            ncyBreadcrumb: {
                label: 'breadcrumb.pages.add'
            },
            params: {type: false},
            resolve: {
                preloadedPages: function (pagesService, errorHandler) {
                    return pagesService.getPages().then(
                        function (response) {
                            return angular.copy(response);
                        },
                        function (error) {
                            errorHandler(error.message)
                            return null
                        }
                    )
                },
                preloadedPageNames: function (pagesService, errorHandler, $stateParams) {
                    return pagesService.getPagesNames({pageType: $stateParams.type || "news"}).then(
                        function (response) {
                            if (response.status == "ok") {
                                return angular.copy(response);
                            }
                            errorHandler(response.message);
                            return null
                        },
                        function (error) {
                            errorHandler(error.message);
                            return null
                        }
                    )
                }
            }
        })
        .state('main.pages.edit', {
            url: "/:pageId/edit",
            templateUrl: "views/pages/edit.html",
            controller: "PagesEditPageController",
            params: {showMain: true, hasItems: true},
            ncyBreadcrumb: {
                parent: function ($scope) {
                    var suffix = "";
                    switch ($scope.pageData.type) {
                        case 'text':
                            suffix = "texts";
                            break;
                        case 'news':
                            suffix = "news";
                            break;
                        case 'category':
                            suffix = "categories";
                            break;
                        case 'sidebar':
                            suffix = "banners";
                            break;
                    }
                    return "main.pages.list." + suffix;
                },
                label: 'breadcrumb.pages.edit'
            },
            resolve: {
                preloadedPageData: function ($stateParams, pagesService, errorHandler, pageStatuses) {
                    var pageId = $stateParams.pageId;
                    return pagesService.getPageItems({page_id: pageId, limit: 10, status: pageStatuses[0]}).then(
                        function (response) {
                            return angular.copy(response);
                        },
                        function (error) {
                            errorHandler(error.message);
                            return null
                        }
                    )
                },
                preloadedPages: function (pagesService, errorHandler, $stateParams) {
                    var pageId = $stateParams.pageId;
                    return pagesService.getCloserPages({id: pageId}).then(
                        function (response) {
                            return angular.copy(response);
                        },
                        function (error) {
                            errorHandler(error.message);
                            return null
                        }
                    )
                }
            }
        })
        .state('main.pages.editDetailed', {
            url: "/:pageId/edit/detailed",
            templateUrl: "views/pages/edit.html",
            controller: "PagesEditPageController",
            params: {showMain: false, hasItems: true},
            ncyBreadcrumb: {
                parent: function ($scope) {
                    var suffix = "",
                        type = $scope.pageData.type || $scope.page.type;
                    switch (type) {
                        case 'text':
                            suffix = "texts";
                            break;
                        case 'news':
                            suffix = "news";
                            break;
                        case 'category':
                            suffix = "categories";
                            break;
                        case 'sidebar':
                            suffix = "banners";
                            break;
                    }
                    return "main.pages.list." + suffix;
                },
                label: 'breadcrumb.pages.edit'
            },
            resolve: {
                preloadedPageData: function ($stateParams, pagesService, errorHandler, pageStatuses) {
                    var pageId = $stateParams.pageId;
                    return pagesService.getPageItems({page_id: pageId, limit: 10, status: pageStatuses[0]}).then(
                        function (response) {
                            return angular.copy(response);
                        },
                        function (error) {
                            errorHandler(error.message);
                            return null
                        }
                    )
                },
                preloadedPages: function (pagesService, errorHandler, $stateParams) {
                    var pageId = $stateParams.pageId;
                    return pagesService.getCloserPages({id: pageId}).then(
                        function (response) {
                            return angular.copy(response);
                        },
                        function (error) {
                            errorHandler(error.message);
                            return null
                        }
                    )
                }
            }
        })
        .state('main.pages.editItem', {
            url: "/:pageId/edit/detailed/:itemId",
            templateUrl: "views/pages/editItem.html",
            controller: "PagesEditItemPageController",
            params: {showMain: false, hasItems: true},
            ncyBreadcrumb: {
                parent: "main.pages.editDetailed",
                label: 'breadcrumb.pages.editItem'
            },
            resolve: {
                preloadedItemData: function (pagesService, $stateParams, errorHandler) {
                    return pagesService.getPageItemById({page_id: $stateParams.pageId, id: $stateParams.itemId}).then(
                        function (response) {
                            if (!!response.page.actualNamesPath) {
                                return pagesService.getByExternalPath(response.page.actualNamesPath).then(
                                    function (namesResponse) {
                                        if (namesResponse.status === "ok") {
                                            var result = angular.copy(response);
                                            result.names = angular.copy(namesResponse.pageNames);
                                            return angular.copy(result)
                                        } else {
                                            return angular.copy(response)
                                        }
                                    },
                                    function () {
                                        return angular.copy(response)
                                    }
                                )
                            }
                            return angular.copy(response)
                        },
                        function (response) {
                            errorHandler(response.message);
                            return null;
                        }
                    )
                }
            }
        })
        .state('main.pages.createItem', {
            url: "/:pageId/edit/create/item",
            templateUrl: "views/pages/editItem.html",
            controller: "PagesCreateItemPageController",
            ncyBreadcrumb: {
                parent: "main.pages.editDetailed",
                label: 'breadcrumb.pages.createItem'
            },
            resolve: {
                preloadedPageData: function ($stateParams, pagesService, errorHandler) {
                    var pageId = $stateParams.pageId;
                    return pagesService.getPageItems({page_id: pageId, limit: 10}).then(
                        function (response) {
                            if (!!response.page.actualNamesPath) {
                                return pagesService.getByExternalPath(response.page.actualNamesPath).then(
                                    function (namesResponse) {
                                        if (namesResponse.status === "ok") {
                                            var result = angular.copy(response);
                                            result.names = angular.copy(namesResponse.pageNames);
                                            return angular.copy(result)
                                        } else {
                                            return angular.copy(response)
                                        }

                                    },
                                    function () {
                                        return angular.copy(response)
                                    }
                                )
                            }
                            return angular.copy(response);
                        },
                        function (error) {
                            errorHandler(error.message);
                            return null
                        }
                    )
                }
            }
        })
        .state('main.pages.list', {
            url: "/all",
            templateUrl: "views/pages/list.html",
            abstract: true,
            ncyBreadcrumb: {
                skip: true
            }
        })
        .state('main.pages.list.banners', {
            url: "/banners",
            templateUrl: "views/pages/templates/banners.html",
            ncyBreadcrumb: {
                parent: "main.configs",
                label: 'breadcrumb.pages.list.banners'
            },
            controller: "PagesListPageController",
            resolve: {
                preloadedPages: function (pagesService, settingsService, errorHandler, pageStatuses, $cookies) {
                    var settings = settingsService.getSettings();
                    return pagesService.getPages({
                        lang: $cookies.get("preferedLanguage") || settings.skin.defaultLang,
                        limit: 10,
                        type: "sidebar",
                        status: pageStatuses[0]
                    }).then(
                        function (response) {
                            return (angular.copy(response) || {});
                        },
                        function (error) {
                            errorHandler(error.message);
                            return null
                        }
                    )
                },
                typeToLoad: function () {
                    return "sidebar"
                }
            }
        })
        .state('main.pages.list.news', {
            url: "/news",
            templateUrl: "views/pages/templates/news.html",
            ncyBreadcrumb: {
                parent: function ($scope) {
                    if ($scope.userData.role !== 'skin_news_manager') {
                        return "main.configs"
                    }
                    return null
                },
                label: 'breadcrumb.pages.list.news'
            },
            controller: "PagesListPageController",
            resolve: {
                preloadedPages: function (pagesService, settingsService, errorHandler, pageStatuses, $cookies) {
                    var settings = settingsService.getSettings();
                    return pagesService.getPages({
                        lang: $cookies.get("preferedLanguage") || settings.skin.defaultLang,
                        limit: 10,
                        type: "news",
                        status: pageStatuses[0]
                    }).then(
                        function (response) {
                            return (angular.copy(response) || {});
                        },
                        function (error) {
                            errorHandler(error.message);
                            return null
                        }
                    )
                },
                typeToLoad: function () {
                    return "news"
                }
            }
        })
        .state('main.pages.list.texts', {
            url: "/texts",
            templateUrl: "views/pages/templates/texts.html",
            ncyBreadcrumb: {
                parent: "main.configs",
                label: 'breadcrumb.pages.list.texts'
            },
            controller: "PagesListPageController",
            resolve: {
                preloadedPages: function (pagesService, settingsService, errorHandler, pageStatuses, $cookies) {
                    var settings = settingsService.getSettings();
                    return pagesService.getPages({
                        lang: $cookies.get("preferedLanguage") || settings.skin.defaultLang,
                        limit: 10,
                        type: "text",
                        status: pageStatuses[0]
                    }).then(
                        function (response) {
                            return (angular.copy(response) || {});
                        },
                        function (error) {
                            errorHandler(error.message);
                            return null
                        }
                    )
                },
                typeToLoad: function () {
                    return "text"
                }
            }
        })
        .state('main.pages.list.categories', {
            url: "/categories",
            templateUrl: "views/pages/templates/categories.html",
            ncyBreadcrumb: {
                parent: "main.configs",
                label: 'breadcrumb.pages.list.categories'
            },
            controller: "PagesListPageController",
            resolve: {
                preloadedPages: function (pagesService, settingsService, errorHandler, pageStatuses, $cookies) {
                    var settings = settingsService.getSettings();
                    return pagesService.getPages({
                        lang: $cookies.get("preferedLanguage") || settings.skin.defaultLang,
                        limit: 10,
                        type: "category",
                        status: pageStatuses[0]
                    }).then(
                        function (response) {
                            return (angular.copy(response) || {});
                        },
                        function (error) {
                            errorHandler(error.message);
                            return null
                        }
                    )
                },
                typeToLoad: function () {
                    return "category"
                }
            }
        })
        .state('main.configs', {
            url: "configs",
            templateUrl: "views/configs/configs.html",
            controller: "ConfigurationsPageController",
            ncyBreadcrumb: {
                label: 'breadcrumb.configs'
            },
            resolve: {
                preloadedConfigs: function (configsService, errorHandler) {
                    return configsService.getConfigsMenu().then(
                        function (response) {
                            return (angular.copy(response.configs) || {});
                        },
                        function (error) {
                            errorHandler(error.message);
                            return null
                        }
                    );
                },
                preloadedConfigTypes: function (configsService, errorHandler) {
                    return configsService.getConfigTypes().then(
                        function (response) {
                            return (angular.copy(response.configTypes) || {});
                        },
                        function (error) {
                            errorHandler(error.message);
                            return null
                        }
                    );
                }
            }
        })
        .state('main.styles', {
            url: "styles",
            templateUrl: "views/styles/styles.html",
            controller: "StylesPageController",
            ncyBreadcrumb: {
                label: 'breadcrumb.styles'
            },
            resolve: {
                preloadedStyles: function (stylesService, errorHandler) {
                    return stylesService.getStylesMenu({status: "published"}).then(
                        function (response) {
                            return (angular.copy(response) || {});
                        },
                        function (error) {
                            errorHandler(error.message);
                            return null
                        }
                    );
                },
                preloadedTemplates: function (templatesService, errorHandler) {
                    return templatesService.getTemplates({status: "published"}).then(
                        function (response) {
                            if (response.status == "ok") {
                                return (angular.copy(response.templates) || []);
                            }
                            errorHandler(response.message);
                            return []
                        },
                        function (response) {
                            errorHandler(response.message);
                            return []
                        }
                    );
                }
            }
        })
        .state('main.media', {
            "url": "media",
            abstract: true,
            templateUrl: "views/media/media.html",
            ncyBreadcrumb: {
                skip: true
            }
        })
        .state('main.media.add', {
            "url": "/add",
            templateUrl: "views/media/add.html",
            controller: "AddMediaPageController",
            ncyBreadcrumb: {
                label: 'breadcrumb.media.add'
            }
        })
        .state('main.media.list', {
            "url": "/list",
            templateUrl: "views/media/list.html",
            controller: "MediasListPageController",
            ncyBreadcrumb: {
                label: 'breadcrumb.media.list'
            },
            resolve: {
                preloadedUsersList: function (userService, errorHandler) {
                    return userService.getAllUsers({includeMe: true}).then(
                        function (response) {
                            if (response && response.status === "ok") {
                                return angular.copy(response);
                            } else {
                                errorHandler((response) ? response.message : "");
                                return null
                            }
                        },
                        function (response) {
                            errorHandler(response.message);
                            return null
                        }
                    )
                },
                preloadedImages: function (mediaService, errorHandler, pageStatuses) {
                    return mediaService.getImages({limit: 10, status: pageStatuses[0]}).then(
                        function (response) {
                            if (response && response.status === "ok") {
                                return angular.copy(response);
                            } else {
                                errorHandler((response) ? response.message : "");
                                return []
                            }
                        },
                        function (response) {
                            errorHandler(response.message);
                            return []
                        }
                    )
                }
            }
        })


        .state('main.skins', {
            "url": "skins",
            abstract: true,
            templateUrl: "views/skins/skins.html",
            ncyBreadcrumb: {
                skip: true
            }
        })
        .state('main.skins.add', {
            "url": "/add",
            templateUrl: "views/skins/add.html",
            controller: "AddSkinPageController",
            ncyBreadcrumb: {
                label: 'breadcrumb.skins.add'
            },
            resolve: {
                preloadedLanguages: function (generalService, errorHandler) {
                    return generalService.getAllLanguages().then(
                        function (response) {
                            if (response.status === "ok") {
                                return angular.copy(response)
                            }
                            errorHandler(response.message);
                            return {}
                        },
                        function (response) {
                            errorHandler(response.message);
                            return {}
                        }
                    )
                }
            }
        })
        .state('main.skins.list', {
            "url": "/list",
            templateUrl: "views/skins/list.html",
            controller: "SkinsListPageController",
            ncyBreadcrumb: {
                label: 'breadcrumb.skins.list'
            },
            resolve: {
                preloadedSkinsList: function (skinService, errorHandler) {
                    return skinService.getAllSkins({limit: 10}).then(
                        function (response) {
                            if (response && response.status === "ok") {
                                return angular.copy(response);
                            } else {
                                errorHandler((response) ? response.message : "");
                                return {}
                            }
                        },
                        function (response) {
                            errorHandler((response) ? response.message : "");
                            return {}
                        }
                    )
                }
            }
        })
        .state('main.skins.edit', {
            "url": "/:skinId/edit",
            templateUrl: "views/skins/edit.html",
            controller: "EditSkinPageController",
            ncyBreadcrumb: {
                parent: 'main.skins.list',
                label: 'breadcrumb.skins.edit'
            },
            resolve: {
                preloadedSkinData: function (skinService, errorHandler, $stateParams) {
                    return skinService.getSkinById({id: $stateParams.skinId}).then(
                        function (response) {
                            if (response.status === "ok") {
                                return angular.copy(response)
                            }
                            return null
                        },
                        function (response) {
                            errorHandler(response.message);
                            return null
                        }
                    )
                },
                preloadedLanguages: function (generalService, errorHandler) {
                    return generalService.getAllLanguages().then(
                        function (response) {
                            if (response.status === "ok") {
                                return angular.copy(response)
                            }
                            errorHandler(response.message);
                            return {}
                        },
                        function (response) {
                            errorHandler(response.message);
                            return {}
                        }
                    )
                }
            }
        })

        .state('main.users', {
            "url": "users",
            abstract: true,
            templateUrl: "views/users/users.html",
            ncyBreadcrumb: {
                skip: true
            }
        })
        .state('main.users.add', {
            "url": "/add",
            templateUrl: "views/users/add.html",
            controller: "AddUserPageController",
            ncyBreadcrumb: {
                label: 'breadcrumb.users.add'
            },
            resolve: {
                preloadedRoles: function (userService, errorHandler) {
                    return userService.getUserRoles().then(
                        function (response) {
                            if (response.status === "ok") {
                                return angular.copy(response)
                            }
                            return null
                        },
                        function (response) {
                            errorHandler(response.message);
                            return null
                        }
                    )
                }
            }
        })
        .state('main.users.list', {
            "url": "/list",
            templateUrl: "views/users/list.html",
            controller: "UsersListPageController",
            ncyBreadcrumb: {
                label: 'breadcrumb.users.list'
            },
            resolve: {
                preloadedUsersList: function (userService, errorHandler, userStatuses) {
                    return userService.getAllUsers({status: userStatuses[0], limit: 10}).then(
                        function (response) {
                            if (response && response.status === "ok") {
                                return angular.copy(response);
                            } else {
                                errorHandler((response) ? response.message : "");
                                return null
                            }
                        },
                        function (response) {
                            errorHandler(response.message);
                            return null
                        }
                    )
                }
            }
        })
        .state('main.users.edit', {
            "url": "/:userId/edit",
            templateUrl: "views/users/edit.html",
            controller: "EditUserPageController",
            ncyBreadcrumb: {
                parent: 'main.users.list',
                label: 'breadcrumb.users.edit'
            },
            resolve: {
                preloadedRoles: function (userService, errorHandler) {
                    return userService.getUserRoles().then(
                        function (response) {
                            if (response.status === "ok") {
                                return angular.copy(response)
                            }
                            return null
                        },
                        function (response) {
                            errorHandler(response.message);
                            return null
                        }
                    )
                },
                preloadedUser: function (userService, errorHandler, $stateParams) {
                    if (!!$stateParams.userId || $stateParams.userId == 0) {
                        return userService.getUserById({id: $stateParams.userId}).then(
                            function (response) {
                                if (response.status === "ok") {
                                    return angular.copy(response.users[0])
                                }
                                return null
                            },
                            function (response) {
                                errorHandler(response.message);
                                return null
                            }
                        )
                    } else {
                        return false
                    }
                }
            }
        })
        .state('main.popups', {
            "url": "popups",
            abstract: true,
            templateUrl: "views/popups/popups.html",
            ncyBreadcrumb: {
                skip: true
            }
        })
        .state('main.popups.add', {
            "url": "/add",
            templateUrl: "views/popups/add.html",
            controller: "AddPopupPageController",
            ncyBreadcrumb: {
                label: 'breadcrumb.popups.add'
            },
            resolve: {
                preloadedNames: function (popupsService, errorHandler) {
                    return popupsService.getActualNames().then(
                        function (response) {
                            if (response.status === "ok") {
                                return angular.copy(response.names)
                            }
                            errorHandler(response.message);
                            return []

                        },
                        function (response) {
                            errorHandler(response.message);
                            return []
                        }
                    )
                }
            }
        })
        .state('main.popups.list', {
            "url": "/list",
            templateUrl: "views/popups/list.html",
            controller: "PopupsListPageController",
            ncyBreadcrumb: {
                label: 'breadcrumb.popups.list'
            },
            resolve: {
                preloadedPopupsList: function (popupsService, errorHandler, pageStatuses, settingsService, $cookies) {
                    var settings = settingsService.getSettings();
                    return popupsService.getPopups({
                        limit: 10,
                        status: pageStatuses[0],
                        lang: $cookies.get("preferedLanguage") || settings.skin.defaultLang
                    }).then(
                        function (response) {
                            if (response.status == "ok") {
                                return angular.copy(response);
                            }
                            errorHandler(response.message);
                            return {}
                        },
                        function (response) {
                            errorHandler(response.message);
                            return {}
                        }
                    )
                }
            }
        })
        .state('main.popups.edit', {
            "url": "/:popupId/edit",
            templateUrl: "views/popups/edit.html",
            controller: "EditPopupPageController",
            ncyBreadcrumb: {
                parent: 'main.popups.list',
                label: 'breadcrumb.popups.edit'
            },
            resolve: {
                preloadedPopupData: function (popupsService, errorHandler, $stateParams) {
                    if (!$stateParams.popupId && $stateParams.popupId != 0) {
                        return {}
                    } else {
                        return popupsService.getPopupById({id: $stateParams.popupId}).then(
                            function (response) {
                                if (response.status == "ok") {
                                    return (response.popup) ? response.popup : {}
                                }
                                errorHandler(response.message);
                                return {}
                            },
                            function (response) {
                                errorHandler(response.message)
                            }
                        )
                    }
                },
                preloadedNames: function (popupsService, errorHandler) {
                    return popupsService.getActualNames().then(
                        function (response) {
                            if (response.status === "ok") {
                                return angular.copy(response.names)
                            }
                            errorHandler(response.message);
                            return []

                        },
                        function (response) {
                            errorHandler(response.message);
                            return []
                        }
                    )
                }
            }
        })

        .state('main.reset', {
            url: "reset",
            templateUrl: "views/reset/reset.html",
            controller: "ResetSkinSettingsPageController",
            ncyBreadcrumb: {
                label: 'breadcrumb.skins.reset'
            }
        })


        /*
         * casino_general_admin_states
         * */

        .state('main.providers', {
            abstract: true,
            url: "providers",
            templateUrl: "views/providers/index.html",
            ncyBreadcrumb: {
                skip: true
            }
        })
        .state('main.providers.add', {
            url: "/add",
            templateUrl: "views/providers/add.html",
            controller: "ProvidersAddPageController",
            ncyBreadcrumb: {
                label: 'breadcrumb.providers.add'
            },
            resolve: {
                preloadedData: function () {
                    return {}
                }
            }
        })
        .state('main.providers.addItem', {
            url: "/:itemId/items/add",
            templateUrl: "views/providers/add.html",
            controller: "ProvidersAddPageController",
            ncyBreadcrumb: {
                parent: 'main.providers.providerItems',
                label: 'breadcrumb.providers.addItem'
            },
            resolve: {
                preloadedData: function (casinoProviderService, pageStatuses, errorHandler) {
                    return casinoProviderService.get({status: pageStatuses[0]}).then(
                        function (response) {
                            if (response.status == "ok") {
                                return angular.copy(response);
                            } else {
                                errorHandler(response.message);
                                return {}
                            }
                        },
                        function (response) {
                            errorHandler(response.message);
                            return {}
                        }
                    )
                }
            }
        })
        .state('main.providers.editItem', {
            url: "/:itemId/items/:providerId/edit",
            templateUrl: "views/providers/edit.html",
            controller: "ProvidersEditPageController",
            ncyBreadcrumb: {
                parent: 'main.providers.providerItems',
                label: 'breadcrumb.providers.editItem'
            },
            resolve: {
                preloadedData: function (casinoProviderService, errorHandler, $stateParams) {
                    return casinoProviderService.get({id: $stateParams.providerId}).then(
                        function (response) {
                            if (response.status == "ok") {
                                return angular.copy(response);
                            } else {
                                errorHandler(response.message);
                                return {}
                            }
                        },
                        function (response) {
                            errorHandler(response.message);
                            return {}
                        }
                    )
                },
                preloadedParents: function (pageStatuses, casinoCategoryService, errorHandler) {
                    return casinoCategoryService.get({status: pageStatuses[0]}).then(
                        function (response) {
                            if (response.status == "ok") {
                                return angular.copy(response);
                            } else {
                                errorHandler(response.message);
                                return {}
                            }
                        },
                        function (response) {
                            errorHandler(response.message);
                            return {}
                        }
                    )
                }
            }
        })
        .state('main.providers.edit', {
            url: "/:providerId/edit",
            templateUrl: "views/providers/edit.html",
            controller: "ProvidersEditPageController",
            ncyBreadcrumb: {
                parent: "main.providers.list",
                label: 'breadcrumb.providers.edit'
            },
            resolve: {
                preloadedData: function (casinoProviderService, $stateParams, errorHandler) {
                    return casinoProviderService.get({name: $stateParams.providerId}).then(
                        function (response) {
                            if (response.status === "ok") {
                                return angular.copy(response);
                            } else {
                                errorHandler(response.message);
                                return {}
                            }
                        },
                        function (response) {
                            errorHandler(response.message);
                            return {}
                        }
                    )
                },
            }
        })
        .state('main.providers.providerItems', {
            url: "/:itemId/items",
            templateUrl: "views/providers/items.html",
            controller: "ProvidersListPageController",
            ncyBreadcrumb: {
                parent: "main.providers.list",
                label: 'breadcrumb.providers.providerItems'
            },
            resolve: {
                preloadedData: function (casinoProviderService, $stateParams, errorHandler, pageStatuses) {
                    return casinoProviderService.get({
                        parent_id: $stateParams.itemId,
                        status: pageStatuses[0],
                        limit: 10,
                        current_page: 1
                    }).then(
                        function (response) {
                            if (response.status === "ok") {
                                return angular.copy(response);
                            } else {
                                errorHandler(response.message);
                                return {}
                            }
                        },
                        function (response) {
                            errorHandler(response.message);
                            return {}
                        }
                    )
                }
            }
        })
        .state('main.providers.list', {
            url: "/all",
            templateUrl: "views/providers/list.html",
            controller: "ProvidersListPageController",
            ncyBreadcrumb: {
                label: 'breadcrumb.providers.list'
            },
            resolve: {
                preloadedData: function (casinoProviderService, pageStatuses, errorHandler) {
                    return casinoProviderService.get({status: pageStatuses[0], limit: 10, current_page: 1}).then(
                        function (response) {
                            if (response.status === "ok") {
                                return angular.copy(response);
                            } else {
                                errorHandler(response.message);
                                return {}
                            }
                        },
                        function (response) {
                            errorHandler(response.message);
                            return {}
                        }
                    )
                }
            }
        })


        .state('main.categories', {
            abstract: true,
            url: "categories",
            templateUrl: "views/categories/index.html",
            ncyBreadcrumb: {
                skip: true
            }
        })
        .state('main.categories.add', {
            url: "/add",
            templateUrl: "views/categories/add.html",
            controller: "CategoriesAddPageController",
            ncyBreadcrumb: {
                label: 'breadcrumb.categories.add'
            },
            resolve: {
                preloadedData: function (casinoCategoryService, pageStatuses, errorHandler) {
                    return casinoCategoryService.get({status: pageStatuses[0]}).then(
                        function (response) {
                            if (response.status == "ok") {
                                return angular.copy(response);
                            } else {
                                errorHandler(response.message);
                                return {}
                            }
                        },
                        function (response) {
                            errorHandler(response.message);
                            return {}
                        }
                    )
                }
            }
        })
        .state('main.categories.addItem', {
            url: "/:itemId/items/add",
            templateUrl: "views/categories/add.html",
            controller: "CategoriesAddPageController",
            ncyBreadcrumb: {
                parent: 'main.categories.categoryItems',
                label: 'breadcrumb.categories.addItem'
            },
            resolve: {
                preloadedData: function (casinoCategoryService, pageStatuses, errorHandler) {
                    return casinoCategoryService.get({status: pageStatuses[0]}).then(
                        function (response) {
                            if (response.status == "ok") {
                                return angular.copy(response);
                            } else {
                                errorHandler(response.message);
                                return {}
                            }
                        },
                        function (response) {
                            errorHandler(response.message);
                            return {}
                        }
                    )
                }
            }
        })
        .state('main.categories.editItem', {
            url: "/:itemId/items/:categoryId/edit",
            templateUrl: "views/categories/edit.html",
            controller: "CategoriesEditPageController",
            ncyBreadcrumb: {
                parent: 'main.categories.categoryItems',
                label: 'breadcrumb.categories.editItem'
            },
            resolve: {
                preloadedData: function (casinoCategoryService, pageStatuses, errorHandler, $stateParams) {
                    return casinoCategoryService.get({id: $stateParams.categoryId}).then(
                        function (response) {
                            if (response.status == "ok") {
                                return angular.copy(response);
                            } else {
                                errorHandler(response.message);
                                return {}
                            }
                        },
                        function (response) {
                            errorHandler(response.message);
                            return {}
                        }
                    )
                },
                preloadedParents: function (pageStatuses, casinoCategoryService, errorHandler) {
                    return casinoCategoryService.get({status: pageStatuses[0]}).then(
                        function (response) {
                            if (response.status == "ok") {
                                return angular.copy(response);
                            } else {
                                errorHandler(response.message);
                                return {}
                            }
                        },
                        function (response) {
                            errorHandler(response.message);
                            return {}
                        }
                    )
                }
            }
        })
        .state('main.categories.edit', {
            url: "/:categoryId/edit",
            templateUrl: "views/categories/edit.html",
            controller: "CategoriesEditPageController",
            ncyBreadcrumb: {
                parent: "main.categories.list",
                label: 'breadcrumb.categories.edit'
            },
            resolve: {
                preloadedData: function (casinoCategoryService, $stateParams, errorHandler) {
                    return casinoCategoryService.get({id: $stateParams.categoryId}).then(
                        function (response) {
                            if (response.status === "ok") {
                                return angular.copy(response);
                            } else {
                                errorHandler(response.message);
                                return {}
                            }
                        },
                        function (response) {
                            errorHandler(response.message);
                            return {}
                        }
                    )
                },
                preloadedParents: function (pageStatuses, casinoCategoryService, errorHandler) {
                    return casinoCategoryService.get({status: pageStatuses[0]}).then(
                        function (response) {
                            if (response.status == "ok") {
                                return angular.copy(response);
                            } else {
                                errorHandler(response.message);
                                return {}
                            }
                        },
                        function (response) {
                            errorHandler(response.message);
                            return {}
                        }
                    )
                }
            }
        })
        .state('main.categories.categoryItems', {
            url: "/:itemId/items",
            templateUrl: "views/categories/items.html",
            controller: "CategoriesListPageController",
            ncyBreadcrumb: {
                parent: "main.categories.list",
                label: 'breadcrumb.categories.categoryItems'
            },
            resolve: {
                preloadedData: function (casinoCategoryService, $stateParams, errorHandler, pageStatuses) {
                    return casinoCategoryService.get({
                        parent_id: $stateParams.itemId,
                        status: pageStatuses[0],
                        limit: 10,
                        current_page: 1
                    }).then(
                        function (response) {
                            if (response.status === "ok") {
                                return angular.copy(response);
                            } else {
                                errorHandler(response.message);
                                return {}
                            }
                        },
                        function (response) {
                            errorHandler(response.message);
                            return {}
                        }
                    )
                }
            }
        })
        .state('main.categories.list', {
            url: "/all",
            templateUrl: "views/categories/list.html",
            controller: "CategoriesListPageController",
            ncyBreadcrumb: {
                label: 'breadcrumb.categories.list'
            },
            resolve: {
                preloadedData: function (casinoCategoryService, pageStatuses, errorHandler) {
                    return casinoCategoryService.get({status: pageStatuses[0], limit: 10, current_page: 1}).then(
                        function (response) {
                            if (response.status === "ok") {
                                return angular.copy(response);
                            } else {
                                errorHandler(response.message);
                                return {}
                            }
                        },
                        function (response) {
                            errorHandler(response.message);
                            return {}
                        }
                    )
                }
            }
        })


        .state('main.games', {
            abstract: true,
            url: "games",
            templateUrl: "views/games/index.html",
            ncyBreadcrumb: {
                skip: true
            }
        })
        .state('main.games.add', {
            url: "/add",
            templateUrl: "views/games/add.html",
            controller: "GamesAddPageController",
            ncyBreadcrumb: {
                label: 'breadcrumb.games.add'
            },
            resolve: {
                preloadedCategories: function (casinoCategoryService, pageStatuses, errorHandler) {
                    return casinoCategoryService.get({status: pageStatuses[0], parent_name: "AllCategories"}).then(
                        function (response) {
                            if (response.status === "ok") {
                                return angular.copy(response.categories)
                            } else {
                                errorHandler(response.message);
                                return {}
                            }
                        },
                        function (response) {
                            errorHandler(response.message);
                            return {}
                        }
                    )
                },
                preloadedSubCategories: function (casinoCategoryService, pageStatuses, errorHandler) {
                    return casinoCategoryService.get({status: pageStatuses[0], parent_name: "AllSubCategories"}).then(
                        function (response) {
                            if (response.status === "ok") {
                                return angular.copy(response.categories)
                            } else {
                                errorHandler(response.message);
                                return {}
                            }
                        },
                        function (response) {
                            errorHandler(response.message);
                            return {}
                        }
                    )
                },
                preloadedProviders: function (casinoProviderService, pageStatuses, errorHandler) {
                    return casinoProviderService.get({status: pageStatuses[0]}).then(
                        function (response) {
                            if (response.status === "ok") {
                                return angular.copy(response.providers)
                            } else {
                                errorHandler(response.message);
                                return {}
                            }
                        },
                        function (response) {
                            errorHandler(response.message);
                            return {}
                        }
                    )
                }
            }
        })
        .state('main.games.edit', {
            url: "/:gameId/edit",
            templateUrl: "views/games/edit.html",
            controller: "GamesEditPageController",
            ncyBreadcrumb: {
                parent: "main.games.list",
                label: 'breadcrumb.games.edit'
            },
            resolve: {
                preloadedGameData: function (casinoGameService, $stateParams, errorHandler) {
                    return casinoGameService.get({id: $stateParams.gameId}).then(
                        function (response) {
                            if (response.status === "ok") {
                                return angular.copy(response.game)
                            } else {
                                errorHandler(response.message);
                                return {}
                            }
                        },
                        function (response) {
                            errorHandler(response.message);
                            return {}
                        }
                    )
                },
                preloadedCategories: function (casinoCategoryService, pageStatuses, errorHandler) {
                    return casinoCategoryService.get({status: pageStatuses[0], parent_name: "AllCategories"}).then(
                        function (response) {
                            if (response.status === "ok") {
                                return angular.copy(response.categories)
                            } else {
                                errorHandler(response.message);
                                return {}
                            }
                        },
                        function (response) {
                            errorHandler(response.message);
                            return {}
                        }
                    )
                },
                preloadedSubCategories: function (casinoCategoryService, pageStatuses, errorHandler) {
                    return casinoCategoryService.get({status: pageStatuses[0], parent_name: "AllSubCategories"}).then(
                        function (response) {
                            if (response.status === "ok") {
                                return angular.copy(response.categories)
                            } else {
                                errorHandler(response.message);
                                return {}
                            }
                        },
                        function (response) {
                            errorHandler(response.message);
                            return {}
                        }
                    )
                },
                preloadedProviders: function (casinoProviderService, pageStatuses, errorHandler) {
                    return casinoProviderService.get({status: pageStatuses[0]}).then(
                        function (response) {
                            if (response.status === "ok") {
                                return angular.copy(response.providers)
                            } else {
                                errorHandler(response.message);
                                return {}
                            }
                        },
                        function (response) {
                            errorHandler(response.message);
                            return {}
                        }
                    )
                }
            }
        })
        .state('main.games.list', {
            url: "/all",
            templateUrl: "views/games/list.html",
            controller: "GamesListPageController",
            ncyBreadcrumb: {
                label: 'breadcrumb.games.list'
            },
            resolve: {
                preloadedData: function (casinoGameService, pageStatuses, errorHandler) {
                    return casinoGameService.get({status: pageStatuses[0], limit: 10}).then(
                        function (response) {
                            if (response.status === "ok") {
                                return angular.copy(response)
                            } else {
                                errorHandler(response.message);
                                return {}
                            }
                        },
                        function (response) {
                            errorHandler(response.message);
                            return {}
                        }
                    )
                },
                preloadedCategories: function (casinoCategoryService, pageStatuses, errorHandler) {
                    return casinoCategoryService.get({status: pageStatuses[0], parent_name: "AllCategories"}).then(
                        function (response) {
                            if (response.status === "ok") {
                                return angular.copy(response.categories)
                            } else {
                                errorHandler(response.message);
                                return {}
                            }
                        },
                        function (response) {
                            errorHandler(response.message);
                            return {}
                        }
                    )
                },
                preloadedSubCategories: function (casinoCategoryService, pageStatuses, errorHandler) {
                    return casinoCategoryService.get({status: pageStatuses[0], parent_name: "AllSubCategories"}).then(
                        function (response) {
                            if (response.status === "ok") {
                                return angular.copy(response.categories)
                            } else {
                                errorHandler(response.message);
                                return {}
                            }
                        },
                        function (response) {
                            errorHandler(response.message)
                            return {}
                        }
                    )
                },
                preloadedProviders: function (casinoProviderService, pageStatuses, errorHandler) {
                    return casinoProviderService.get({status: pageStatuses[0]}).then(
                        function (response) {
                            if (response.status === "ok") {
                                return angular.copy(response.providers)
                            } else {
                                errorHandler(response.message);
                                return {}
                            }
                        },
                        function (response) {
                            errorHandler(response.message);
                            return {}
                        }
                    )
                }
            }
        })
        .state('main.games.switchSkins', {
            url: "/:gameId/switchSkins",
            templateUrl: "views/games/switchSkins.html",
            controller: "GamesSwitchSkinsPageController",
            ncyBreadcrumb: {
                parent: "main.games.list",
                label: 'breadcrumb.games.switchSkins'
            },
            resolve: {
                preloadedGameData: function (casinoGameService, $stateParams, errorHandler) {
                    return casinoGameService.get({id: $stateParams.gameId, withSkins: true}).then(
                        function (response) {
                            if (response.status === "ok") {
                                return angular.copy(response.game)
                            } else {
                                errorHandler(response.message);
                                return {}
                            }
                        },
                        function (response) {
                            errorHandler(response.message);
                            return {}
                        }
                    )
                },
                preloadedSkinsList: function (skinService, errorHandler, pageStatuses) {
                    return skinService.getAllSkins({status: pageStatuses[0]}).then(
                        function (response) {
                            if (response && response.status === "ok") {
                                return angular.copy(response);
                            } else {
                                errorHandler((response) ? response.message : "");
                                return {}
                            }
                        },
                        function (response) {
                            errorHandler((response) ? response.message : "");
                            return {}
                        }
                    )
                }
            }
        })
        .state('main.casinoGames', {
            abstract: true,
            url: "casino_games",
            templateUrl: "views/casinoGames/index.html",
            ncyBreadcrumb: {
                skip: true
            }
        })
        .state('main.casinoGames.list', {
            url: "/all",
            templateUrl: "views/casinoGames/list.html",
            controller: "CasinoGamesListPageController",
            ncyBreadcrumb: {
                label: 'breadcrumb.casinoGames.list'
            },
            resolve: {
                preloadedData: function (casinoGameService, pageStatuses, errorHandler) {
                    return casinoGameService.getSkinGames({active: true, limit: 10}).then(
                        function (response) {
                            if (response.status === "ok") {
                                return angular.copy(response)
                            } else {
                                errorHandler(response.message);
                                return {}
                            }
                        },
                        function (response) {
                            errorHandler(response.message);
                            return {}
                        }
                    )
                },
                preloadedCategories: function (casinoCategoryService, pageStatuses, errorHandler) {
                    return casinoCategoryService.get({status: pageStatuses[0], parent_name: "AllCategories"}).then(
                        function (response) {
                            if (response.status === "ok") {
                                return angular.copy(response.categories)
                            } else {
                                errorHandler(response.message);
                                return {}
                            }
                        },
                        function (response) {
                            errorHandler(response.message);
                            return {}
                        }
                    )
                },
                preloadedSubCategories: function (casinoCategoryService, pageStatuses, errorHandler) {
                    return casinoCategoryService.get({status: pageStatuses[0], parent_name: "AllSubCategories"}).then(
                        function (response) {
                            if (response.status === "ok") {
                                return angular.copy(response.categories)
                            } else {
                                errorHandler(response.message);
                                return {}
                            }
                        },
                        function (response) {
                            errorHandler(response.message);
                            return {}
                        }
                    )
                },
                preloadedProviders: function (casinoProviderService, pageStatuses, errorHandler) {
                    return casinoProviderService.get({status: pageStatuses[0]}).then(
                        function (response) {
                            if (response.status === "ok") {
                                return angular.copy(response.providers)
                            } else {
                                errorHandler(response.message);
                                return {}
                            }
                        },
                        function (response) {
                            errorHandler(response.message);
                            return {}
                        }
                    )
                }
            }
        })
        .state('main.casinoGames.edit', {
            url: "/:gameId/edit",
            templateUrl: "views/casinoGames/edit.html",
            controller: "CasinoGamesEditPageController",
            ncyBreadcrumb: {
                parent: "main.casinoGames.list",
                label: 'breadcrumb.casinoGames.edit'
            },
            resolve: {
                preloadedGameData: function (casinoGameService, $stateParams, errorHandler) {
                    return casinoGameService.getSkinGames({gameSkinId: $stateParams.gameId}).then(
                        function (response) {
                            if (response.status === "ok") {
                                return angular.copy({
                                    id: response.skinGame.gameSkinId,
                                    active: response.skinGame.active,
                                    categories: response.skinGame.categories,
                                    subCategories: response.skinGame.subCategories
                                })
                            } else {
                                errorHandler(response.message);
                                return {}
                            }
                        },
                        function (response) {
                            errorHandler(response.message);
                            return {}
                        }
                    )
                },
                preloadedCategories: function (casinoCategoryService, pageStatuses, errorHandler) {
                    return casinoCategoryService.get({status: pageStatuses[0], parent_name: "AllCategories"}).then(
                        function (response) {
                            if (response.status === "ok") {
                                return angular.copy(response.categories)
                            } else {
                                errorHandler(response.message);
                                return {}
                            }
                        },
                        function (response) {
                            errorHandler(response.message);
                            return {}
                        }
                    )
                },
                preloadedSubCategories: function (casinoCategoryService, pageStatuses, errorHandler) {
                    return casinoCategoryService.get({status: pageStatuses[0], parent_name: "AllSubCategories"}).then(
                        function (response) {
                            if (response.status === "ok") {
                                return angular.copy(response.categories)
                            } else {
                                errorHandler(response.message);
                                return {}
                            }
                        },
                        function (response) {
                            errorHandler(response.message);
                            return {}
                        }
                    )
                }
            }
        }).state('main.hiddenGames', {
            url: "hiddenGames",
            templateUrl: "views/hiddenGames/list.html",
            controller: "HiddenGamesListPageController",
            ncyBreadcrumb: {
                label: 'breadcrumb.hiddenGames.list'
            },
            resolve: {
                preloadedProviders: function (hiddenGamesService, errorHandler) {
                    return hiddenGamesService.getProviders().then(
                        function (response) {
                            if (response.status === "ok") {
                                delete response.status;
                                return angular.copy(response)
                            } else {
                                errorHandler(response.message);
                                return {}
                            }
                        },
                        function (response) {
                            errorHandler(response.message);
                            return {}
                        }
                    )
                },
                preloadedCategories: function (hiddenGamesService, errorHandler) {
                    return hiddenGamesService.getCategories().then(
                        function (response) {
                            if (response.status === "ok") {
                                delete response.status;
                                return angular.copy(response)
                            } else {
                                errorHandler(response.message);
                                return {}
                            }
                        },
                        function (response) {
                            errorHandler(response.message);
                            return {}
                        }
                    )
                }
            }
        })

}).config(function ($breadcrumbProvider) {
    $breadcrumbProvider.setOptions({
        templateUrl: "views/breadcrumb/breadcrumbTemplate.html"
    });
});


//angular-material#master